import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import AdminPromotionRelegation from './AdminPromotionRelegation';
import AdminCampaignCarryPromotion from './AdminCampaignCarryPromotion';
import AdminSkillLevelAlignment from './AdminSkillLevelAlignment';
import { consumeAdminNavHandoff } from '../utils/adminNavFilters';

const BRAND = { blue: '#043663', muted: '#64748b' };

const Page = styled.div`
  max-width: 1280px;
`;

const Header = styled.div`
  margin-bottom: 1rem;
  h2 {
    margin: 0 0 0.35rem;
    font-size: 1.65rem;
    font-weight: 800;
    color: #0f172a;
    letter-spacing: -0.02em;
  }
  p {
    margin: 0;
    color: ${BRAND.muted};
    font-size: 0.9rem;
    max-width: 48rem;
    line-height: 1.45;
  }
`;

const Tabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-bottom: 1.15rem;
`;

const Tab = styled.button`
  padding: 0.45rem 0.85rem;
  border-radius: 999px;
  border: 1px solid ${(p) => (p.$active ? BRAND.blue : '#e2e8f0')};
  background: ${(p) => (p.$active ? BRAND.blue : '#fff')};
  color: ${(p) => (p.$active ? '#fff' : '#475569')};
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
`;

export const PROMOTION_HUB_SECTION_TO_TAB = {
  'promotion-relegation': 'season',
  'campaign-carry-promotion': 'campaign',
};

const TABS = [
  { id: 'season', label: 'Phase placement' },
  { id: 'campaign', label: 'Season carry' },
  { id: 'skill', label: 'Skill alignment' },
];

export default function AdminPromotionSystemHub() {
  const [tab, setTab] = useState('season');

  useEffect(() => {
    const h = consumeAdminNavHandoff();
    if (!h) return;
    if (h.promotionHubTab && TABS.some((t) => t.id === h.promotionHubTab)) {
      setTab(h.promotionHubTab);
      return;
    }
    if (h.section && PROMOTION_HUB_SECTION_TO_TAB[h.section]) {
      setTab(PROMOTION_HUB_SECTION_TO_TAB[h.section]);
    }
  }, []);

  return (
    <Page>
      <Header>
        <h2>Promotion system</h2>
        <p>
          Phase-to-phase team placement, and season-to-season top-two carry promotion for continuing teams.
        </p>
      </Header>

      <Tabs>
        {TABS.map((t) => (
          <Tab key={t.id} type="button" $active={tab === t.id} onClick={() => setTab(t.id)}>
            {t.label}
          </Tab>
        ))}
      </Tabs>

      {tab === 'season' ? <AdminPromotionRelegation /> : null}
      {tab === 'campaign' ? <AdminCampaignCarryPromotion /> : null}
      {tab === 'skill' ? <AdminSkillLevelAlignment /> : null}
    </Page>
  );
}
